'use es6';

import { Map as ImmutableMap } from 'immutable';
import { fromMetricKey } from 'reporting-data/v2/dataset/datasetMetrics';
import SenderScoreCell from './SenderScoreCell';
import BarChartCell from './BarChartCell';
import ScriptedPropertyCell from './ScriptedPropertyCell';
export const SEQUENCE_SENDER_SCORE_CELL = 'SEQUENCE_SENDER_SCORE';
export const SHOW_AS_BAR_CHART_CELL = 'SHOW_AS_BAR_CHART';
export const SHOW_SCRIPTED_CELL = 'SHOW_SCRIPTED_CELL';
const customRendererMap = {
  [SEQUENCE_SENDER_SCORE_CELL]: SenderScoreCell,
  [SHOW_AS_BAR_CHART_CELL]: BarChartCell,
  [SHOW_SCRIPTED_CELL]: ScriptedPropertyCell
};
export const getCustomRenderer = rendererKey => customRendererMap[rendererKey] || null;
const mapReportToRendererKey = ImmutableMap({
  [SEQUENCE_SENDER_SCORE_CELL]: ({
    report,
    column: {
      field
    }
  }) => report.getIn(['config', 'dataType']) === 'SEQUENCE_SENDER_SCORE' && fromMetricKey(field).property === 'senderScore',
  [SHOW_AS_BAR_CHART_CELL]: ({
    column: {
      showAsBarChart
    }
  }) => showAsBarChart,
  [SHOW_SCRIPTED_CELL]: ({
    report,
    dataMap,
    column: {
      field
    }
  }) => report.getIn(['config', 'configType']) === 'SEARCH' && dataMap.getIn(['primary', 'data', 'properties', field, 'scripted'], false)
});
export const getCustomRendererKey = args => mapReportToRendererKey.findKey(predicate => predicate(args));